const isImage = (file: File) =>
  ["jpg", "jpeg", "png"].some((format) => file.type?.indexOf(format) !== -1);

export default isImage;
